<template>
  <v-container class="col-12">
    <v-card class="pa-4">
      <v-row class="mx-0">
        <select-project
          v-model="project"
          class="col-1"
          style="min-width: 250px; max-width: 250px"
        ></select-project>

        <v-btn color="info" v-on:click="search" class="mt-3" :disabled="loading" :loading="loading">Search</v-btn>

        <v-col
          cols="6"
          class="ml-auto"
        >
          <v-card
            :loading="isLoadingProjectOveriview"
            outlined
            rounded="xl"
          >
            <v-row>
              <v-col>
                <v-card-subtitle class="py-0 grey--text text--darken-1">
                  <v-icon small>
                    mdi-credit-card-outline
                  </v-icon>
                  Total balances
                </v-card-subtitle>

                <v-card-title class="py-0">
                  {{ projectOverview.total_balances }}
                </v-card-title>
              </v-col>
              <v-divider vertical />
              <v-col>
                <v-card-subtitle class="py-0 pl-0 grey--text text--darken-1">
                  <v-icon small>
                    mdi-arrow-top-right
                  </v-icon>
                  Total withdrawals
                </v-card-subtitle>

                <v-card-title class="py-0 pl-0">
                  {{ projectOverview.total_withdrawals }}
                </v-card-title>
              </v-col>
              <v-divider vertical />
              <v-col>
                <v-card-subtitle class="py-0 pl-0 grey--text text--darken-1">
                  <v-icon small>
                    mdi-percent
                  </v-icon>
                  WD / dep · month
                </v-card-subtitle>

                <v-card-title class="py-0 pl-0">
                  {{ projectOverview.this_month_w2d }}%
                </v-card-title>
              </v-col>
              <v-divider vertical />
              <v-col class="d-flex align-center">
                <v-card-subtitle class="py-0 pl-0 grey--text text--darken-1">
                  <v-icon>
                    mdi-refresh
                  </v-icon>
                  last updated: {{ fmtDateDiff(projectOverview.date) }}
                </v-card-subtitle>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card>


    <v-card class="pa-0 mt-4">
      <v-select
        v-if="!loading"
        :value="selectedColumns"
        @input="(columns) => setSelectedColumns(columns, 'withdraw')"
        :items="headers.filter(({text}) => !!text)"
        hide-details
        multiple
        persistent-placeholder
        prepend-inner-icon="mdi-menu"
        append-icon=""
        class="data-table__select-row mr-5"
        style="width: 0"
      >
        <template v-slot:selection="{ item, index }" />
      </v-select>
      <v-data-table
        :loading="loading"
        :server-items-length="total"
        :headers="tableHeaders"
        sort-by="created"
        sort-desc
        :options.sync="options"
        :items="items"
        :expanded.sync="expanded"
        item-key="account_transaction_id"
        :footer-props="{'items-per-page-options': [15, 25, 50, 100]}"
        :items-per-page="25"
        show-expand
        :class="{'payment-handler-dt': true, 'footer-padding': $store.state.auth.checkAccess({key: 'kiosk.access', value: true})}"
        style="z-index: 0; position: relative;"
      >
        <template v-slot:body.prepend>
          <tr class="grey lighten-3">
            <td
              v-for="header in tableHeaders"
              :key="'ph-dt-filter-' + (header.value)"
              style="border: none"
            >
              <v-select
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                return-object
                single-line
                class="data-table-finance-filter-select"
                :items="header.data || getSelectFilterValue(header.value)"
                v-model="filters[header.value].data"
              />
              <v-combobox
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'combobox'"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                return-object
                single-line
                class="data-table-finance-filter-select"
                :items="header.data || columnValueList(header.value)"
                v-model="filters[header.value].data"
              />
              <v-text-field
                class="data-table-finance-filter-textfield"
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
                v-model="filters[header.value].data"
                hide-details
              />
            </td>
          </tr>
        </template>

        <template v-slot:expanded-item="{ headers , item }">
          <td :colspan="headers.length">
            <v-row class="col-12 px-5 pb-0 payment-handler-details">

              <v-text-field
                :value="item.account_transaction_id"
                label="ID"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.login"
                label="Login"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.type"
                label="Type"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.status"
                label="Status"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.amount"
                :label="`Amount (${item.currency})`"
                :suffix="item.currency"
                small
                outlined
                readonly
                hide-details
                class="col-1 text-right"
              ></v-text-field>
              <v-text-field
                :value="item.amount_eur"
                label="Amount (EUR)"
                suffix="EUR"
                small
                outlined
                readonly
                hide-details
                class="col-1 text-right"
              ></v-text-field>
              <v-text-field
                :value="item.account"
                label="Account"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.paymethod"
                label="Paymethod"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.paysystem"
                label="Paysystem"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.created"
                label="Created"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.updated"
                label="Updated"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.account_info.profile.name"
                label="Name"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
              <v-text-field
                :value="item.account_info.profile.surname"
                label="Surname"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>

              <v-text-field
                v-for="(param, key) in (item.details.params || {})"
                :key="'transaction-details-' + key"
                :value="param"
                :label="startCase(key)"
                small
                outlined
                readonly
                hide-details
                class="col-2"
              ></v-text-field>
            </v-row>

            <v-row class="col-12 px-5 pt-0 payment-handler-details">


            </v-row>

            <v-divider class="mx-5" />

            <account-message-presets
              :transaction="item"
              :message-presets="MESSAGE_PRESETS"
              :project-has-account-messages="projectHasAccountMessages"
              :readonly="!$store.state.auth.checkAccess({key: 'payment_handler_update', value: true})"
              @select-preset="applyAccountMessagePreset(item, $event)"
            />
          </td>
        </template>

        <!-- <template v-slot:header.status="{header}">
          {{ header.text }}
          <v-icon
            v-if="hadStatusFilterOnLoad"
            small
            color="primary"
            title="Saved status filters applied"
          >
            mdi-filter-check
          </v-icon>
        </template> -->

        <template v-slot:item.login="{ item, header }">
          <a :href="'/user-management/' + item.login " target="_blank">{{ item.login }}</a>
          <v-icon>arrow-up</v-icon>
        </template>
        <template v-slot:item.account_id="{ item, header }">
          <span style="white-space: nowrap">
            <v-icon :color="item.withdraw_alert ? 'green' : 'red'" :title="'Total withdraws: ' + item.total_withdraw_eur + 'EUR'" small>
              {{ item.withdraw_alert ? 'mdi-arrow-up-bold' : 'mdi-arrow-down-bold' }}
            </v-icon>
            <a :href="'/user-management/' + item.login " target="_blank">{{ item.account_id }}</a>
            <v-icon v-if="item.first_withdraw" class="ml-1" title="First Withdraw" small>mdi-numeric-1-box</v-icon>
          </span>
        </template>

        <template v-slot:item.account="{ item }">
          <div style="max-width: 170px; overflow: hidden; text-overflow: ellipsis" class="nowrap">
            {{ item.account }}
          </div>
        </template>

        <template v-slot:item.amount="{value, item}">
          {{ value }} {{ item.currency }}
          <v-tooltip v-if="item.details.express_withdrawal_details" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                help
              </v-icon>
            </template>
            <span>Express withdrawal, fee: {{ item.details.express_withdrawal_details.fee }}</span>
          </v-tooltip>
        </template>

        <template v-slot:item.created="{ item }">
          <div style="min-width: 135px;">
            {{ item.created }}
          </div>
        </template>

        <template v-slot:item.updated="{ item }">
          <div style="min-width: 135px;">
            {{ item.updated }}
          </div>
        </template>

        <template v-slot:item.status="{ item }">
          <v-tooltip bottom open-on-click v-if="!item.details.kyc.review">
            <template v-slot:activator="{ on, attrs }">
              <v-select
                :items="statuses"
                v-model="item.status"
                v-bind="attrs"
                v-on="on"
                readonly
                dense
                hide-details
                x-small
                class="mt-0"
                style="max-width: 150px;"
              ></v-select>
            </template>
            <span>Review before you can change status</span>
          </v-tooltip>
          <v-select
            v-else
            :items="statuses"
            v-model="item.status"
            :readonly="!(item.details.kyc.review) || !$store.state.auth.checkAccess({key: 'payment_handler_update', value: true})"
            dense
            hide-details
            x-small
            class="mt-0"
            style="max-width: 150px;"
          ></v-select>
        </template>
        <template v-slot:item.details.kyc.verified="{ item }">
          <v-btn
            small
            :color="item.details.kyc.verified ? 'primary' : 'info'"
            @click="updateTransaction(item, {afterConfirm: () => item.details.kyc.verified = !item.details.kyc.verified})"
            :disabled="!$store.state.auth.checkAccess({key: 'payment_handler_update', value: true})"
          >
            Verified
          </v-btn>
        </template>
        <template v-slot:item.withdraw-action="{ item }">
          <v-btn
            v-if="$store.state.auth.checkAccess({key: 'payout', value: true})"
            small
            color="primary"
            :disabled="!(item.details.kyc.verified && item['status'] == 'pending') || (projectHasAccountMessages && !item.details.account_message.withdrawal_date)"
            @click="$store.state.auth.checkAccess({key: 'payout', value: true}) ? openPayoutDialog(item) : false"
          >
            Payout
          </v-btn>
        </template>
        <template v-slot:item.details.kyc.docs_approved="{ item }">
          <v-checkbox
            v-model="item.details.kyc.bills && item.details.kyc.id_card && item.details.kyc.psp && item.details.kyc.selfie"
            hide-details
            readonly
            class="mt-0 pt-0"
          ></v-checkbox>
        </template>
        <template v-slot:item.details.kyc.review="{ item }">
          <v-checkbox
            v-model="item.details.kyc.review"
            hide-details
            class="mt-0 pt-0"
            :readonly="!$store.state.auth.checkAccess({key: 'payment_handler_update', value: true})"
          ></v-checkbox>
        </template>
        <template v-slot:item.edit="{ item }">
          <v-btn
            v-if="transactionDetailsCanBeConfigured(item)"
            icon
            @click="editDetailsTransaction = item"
          >
            <v-icon>
              mdi-cog
            </v-icon>
          </v-btn>
        </template>
        <template v-slot:item.comment="{ item }">
          <div style="min-width: 250px;">
            <v-text-field
              v-model="item.comment"
              placeholder="Comment"
              auto-grow
              rows="1"
              hide-details
              clearable
              :readonly="!$store.state.auth.checkAccess({key: 'payment_handler_update', value: true})"
              :append-icon="$store.state.auth.checkAccess({key: 'payment_handler_update', value: true}) ? 'mdi-content-save' : ''"
              @click:append="projectHasAccountMessages ? confirmationTarget = item : updateTransaction(item)"
              class="payment-handler-update-comment pa-0 ma-0"
            >
              <template #prepend-inner>
                <v-menu offset-y max-height="400" v-if="DESCRIPTION_PRESETS.length > 0">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      small
                      v-bind="attrs"
                      v-on="on"
                      class="px-0"
                      style="float: left; min-width: 20px; margin-right: 3px"
                    >
                      <v-icon>keyboard_arrow_down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="preset in DESCRIPTION_PRESETS"
                      :key="preset.description + preset.type"
                      @click="applyDescriptionPreset(item, preset)"
                    >
                      <v-list-item-title>{{ preset.description }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-text-field>
          </div>
        </template>

        <template v-slot:item.details.account_message.withdrawal_date="{ item }">
          <v-menu
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            @input="$event ? loadDateStats(item) : null"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="item.details.account_message.withdrawal_date"
                append-icon="event"
                @click:append="setTomorrowDate(item)"
                placeholder="YYYY-MM-DD"
                hide-details
                v-on="on"
                class="pt-0 mt-0 date-input"
                @input="applyAccountMessagePreset(item, { message: ESTIMATED_DATE_MSG, type: ACCOUNT_MSG_TYPE_ESTIMATE })"
              />
            </template>

            <v-date-picker
              v-model="item.details.account_message.withdrawal_date"
              no-title
              scrollable
              :events="(date) => dateEvents(item.account_id, date, item.account_transaction_id)"
              @input="applyAccountMessagePreset(item, { message: ESTIMATED_DATE_MSG, type: ACCOUNT_MSG_TYPE_ESTIMATE })"
            >
              <v-row>
                <v-col
                  cols="12"
                  class="pb-0 text-caption"
                >
                  <div class="purple legend-dot" /> This transaction's current scheduled date
                </v-col>
                <v-col
                  cols="12"
                  class="py-0 text-caption"
                >
                  <div class="primary legend-dot" /> Date with another withdrawal scheduled
                </v-col>
                <v-col
                  cols="12"
                  class="py-0 text-caption"
                >
                  <div class="warning legend-dot" /> Date with multiple withdrawals scheduled
                </v-col>
                <v-col
                  cols="12"
                  class="d-flex align-center justify-end py-0"
                >
                  <v-btn
                    text
                    color="primary"
                    @click="item.details.account_message.withdrawal_date = null"
                  >Clear</v-btn>
                </v-col>
              </v-row>
            </v-date-picker>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>


    <v-dialog
      v-model="payoutDialog.show"
      width="400"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Payout
        </v-card-title>

        <v-card-text class="px-6 pb-0 pt-2">
          <v-row v-if="payoutDialog.balances.length > 0" class="pb-2">
            <template v-for="row of payoutDialog.balances">
              <v-chip v-if="row.balance > 0" class="px-2 ma-1" outlined label @click="changeWallet(payoutDialog.data.transaction, row)">
                {{ row.currency }}: {{ row.balance }}
              </v-chip>
            </template>
          </v-row>
          <v-row>
            <v-text-field
              :loading="payoutDialog.loadingWalletSwitch"
              label="Amount"
              v-model="payoutDialog.data.transaction.amount"
              hide-details
              readonly
              :suffix="payoutDialog.data.transaction.currency"
              class="col-6"
            ></v-text-field>
            <v-text-field
              label="Amount EUR"
              v-model="payoutDialog.data.transaction.amount_eur"
              hide-details
              readonly
              suffix="EUR"
              class="col-6"
            ></v-text-field>
          </v-row>

          <v-combobox
            label="Account"
            item-text="account"
            item-value="token"
            :return-object="false"
            v-model="payoutDialog.data.account"
            :items="payoutDialog.data.withdraw_tokens"
            :loading="payoutDialog.loadingAccount"
            :readonly="payoutDialog.loadingAccount"
            ref="token_id_cb"
          ></v-combobox>


          <v-text-field
            v-for="(param, key) in (payoutDialog.data.fields || {})"
            :key="key"
            v-model="payoutDialog.data.fields[key]"
            :label="startCase(key)"
            hide-details
          ></v-text-field>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            outlined
            :disabled="payoutInProgress"
            @click="payoutDialog.show = false"
          >
            Close
          </v-btn>
          <v-btn
            :disabled="payoutInProgress || payoutDialog.loadingWalletSwitch"
            :loading="payoutInProgress"
            color="success"
            outlined
            @click="payoutHandler(payoutDialog.data.transaction, payoutDialog.data.fields, payoutDialog.data.account)"
          >
            Payout
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="editTransactionDialog"
      max-width="1200"
    >
      <transaction-details-form
        v-if="editDetailsTransaction"
        :transaction="editDetailsTransaction"
        :is-loading="isUpdatingTransactionDetails"
        @close="editTransactionDialog = false"
        @update="onTransactionDetailsUpdate"
      />
    </v-dialog>

    <v-dialog
      v-model="isConfirmationDisplayed"
      max-width="560"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
          dense
          flat
        >
          <v-toolbar-title class="white--text">Confirm</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pa-4">
          Do you want to save changes?

          <account-message-presets
            v-if="isConfirmationDisplayed"
            :transaction="confirmationTarget"
            :message-presets="MESSAGE_PRESETS"
            :project-has-account-messages="projectHasAccountMessages"
            :readonly="!$store.state.auth.checkAccess({key: 'payment_handler_update', value: true})"
            hide-comment
            @select-preset="applyAccountMessagePreset(confirmationTarget, $event)"
          />
        </v-card-text>

        <v-card-actions class="d-flex justify-end">
          <v-btn
            text
            @click="isConfirmationDisplayed = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            outlined
            @click="onCustomConfirm"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>
<style lang="scss" scoped>
  @import './payment-table.scss';

  ::v-deep.payment-handler-details .col-1.v-input {
    max-width: 8.3333333333%;
  }

  ::v-deep.payment-handler-details .col-2.v-input {
    max-width: 16.666%;
  }

  ::v-deep.payment-handler-dt th {
    padding: 6px 2px !important;
    text-align: center;
  }

  ::v-deep.payment-handler-dt td {
    padding: 6px 5px !important;
    height: auto !important;
  }


  ::v-deep .payment-handler-dt td.pl-0-i {
    padding-left: 0 !important;
  }

  ::v-deep .payment-handler-dt td.pr-0-i {
    padding-right: 0 !important;
  }

  .legend-dot {
    display: inline-block;
    border-radius: 50%;
    height: 8px;
    margin: 0 1px;
    width: 8px;
  }

  .date-input {
    min-width: 115px
  }
  .date-input {
    ::v-deep input::placeholder {
      font-size: 14px;
    }
  }
</style>

<script>

  import { map, clone, cloneDeep, trim, get, set, find, startCase, reduce, isEmpty, isString, findIndex, omit } from 'lodash'
  import { API } from '@/utils/api'
  import moment from 'moment'
  import WithdrawComments from '@/components/helper/WithdrawComments.vue'
  import { userSelectColumnsMixin } from './userSelectColumnsMixin'
  import selectFilterValueMixin from './selectFilterValueMixin'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import vueJsonEditor from 'vue-json-editor'
  import TransactionDetailsForm from './TransactionDetailsForm.vue'
  import { DESCRIPTION_PRESETS, ESTIMATED_DATE_MSG, MESSAGE_PRESETS, ACCOUNT_MSG_TYPE_ESTIMATE } from './consts.js'
  import AccountMessagePresets from './AccountMessagePresets'

  const STATUS_OPTIONS = [ 'pending', 'complete', 'cancel', 'decline', 'error', 'processing', ]
  const STATUS_LOCAL_STORAGE_KEY = 'payment-handler:withdraw:status_filter'

  const WITHDRAWAL_DATE_KEY = 'details.account_message.withdrawal_date'
  const KYC_VERIFICATION_KEY = 'details.kyc.verified'

  export default {

    props: [ 'title' ],
    mixins: [ userSelectColumnsMixin, selectFilterValueMixin ],
    components: {
      SelectProject,
      WithdrawComments,
      vueJsonEditor,
      TransactionDetailsForm,
      AccountMessagePresets,
    },
    data() {
      let hadStatusFilterOnLoad = false
      let statusFilterOptions = [ 'pending', 'processing' ]

      const savedStatusFilter = window.localStorage.getItem(STATUS_LOCAL_STORAGE_KEY)
      if (savedStatusFilter !== null) {
        const savedSelectedOptions = savedStatusFilter.split(',').filter(option => STATUS_OPTIONS.includes(option))
        hadStatusFilterOnLoad = true
        statusFilterOptions = savedSelectedOptions
      }

      return {
        expanded: [],
        entities: false,
        headers: [
          { text: '#', value: 'withdraw-action', sortable: false, 'class': 'nowrap' },
          { text: 'Created', value: 'created', 'class': 'nowrap' },
          { text: 'LastUpdate', value: 'updated', 'class': 'nowrap' },
          { text: 'AccountID', value: 'account_id', sortable: false, 'class': 'nowrap' },
          { text: 'Level', value: 'level', sortable: true, 'class': 'nowrap' },
          { text: 'Login', value: 'login', sortable: false, 'class': 'nowrap', defaultHide: true },
          // { text: 'TransactionID', value: 'account_transaction_id', sortable: false, 'class': 'nowrap' },
          { text: 'Amount', value: 'amount', 'class': 'nowrap' },
          // { text: 'Currency', value: 'currency', 'class': 'nowrap' },
          { text: 'In EUR', value: 'amount_eur', 'class': 'nowrap' },
          { text: 'Paymethod', value: 'paymethod', 'class': 'nowrap', data: [] },
          { text: 'Paysystem', value: 'paysystem', 'class': 'nowrap' },
          { text: 'Status', value: 'status', 'class': 'nowrap' },
          { text: 'By', value: 'operator', 'class': 'nowrap', sortable: false },
          { text: 'Account', value: 'account', 'class': 'nowrap' },
          { text: 'Verify', value: 'details.kyc.verified', 'class': 'nowrap', sortable: false, },
          { text: 'Docs', value: 'details.kyc.docs_approved', 'class': 'nowrap', sortable: false, },
          { text: 'Review', value: 'details.kyc.review', 'class': 'nowrap', sortable: false, },
          { text: 'Description', align: 'left', sortable: false, value: 'comment', 'class': 'nowrap', cellClass: 'pr-0-i' },
          { text: 'Withdrawal Date', align: 'left', sortable: true, value: WITHDRAWAL_DATE_KEY, 'class': 'nowrap', },
          { text: '', value: 'data-table-expand', 'class': 'nowrap' },
        ],
        filters: {
          status: { data: statusFilterOptions, type: 'select' },
          paymethod: { data: [], type: 'combobox' },
          paysystem: { data: [], type: 'select' },
          account: { data: [], type: 'text' },
          account_id: { data: [], type: 'text' },
        },
        statuses: STATUS_OPTIONS,
        hadStatusFilterOnLoad,
        project: null,
        loading: false,
        payoutInProgress: false,
        payoutDialog: {
          loadingWalletSwitch: false,
          loadingAccount: false,
          loadingBalances: false,
          balances: [],
          show: false,
          data: {
            account: '',
            fields: {},
            transaction: {},
            withdraw_tokens: [],
          }
        },
        editDetailsTransaction: null,
        isUpdatingTransactionDetails: false,
        items: [],
        itemsInit: [],
        options: {},
        total: 0,

        isLoadingProjectOveriview: false,
        projectOverview: {},

        MESSAGE_PRESETS,
        DESCRIPTION_PRESETS,
        ESTIMATED_DATE_MSG,
        ACCOUNT_MSG_TYPE_ESTIMATE,

        confirmationTarget: null,
        withdrawalSchedulesByAccountId: {},
      }
    },

    /*
    Убрать:
First withdrawal —- (verify)
Skype Call Verification
Skype Call Verification failed
Deduction reason: BUG
Cancel: Verification failed
Request withdraw via Bank
Waiting for minimal deposit
Добавить:
Provider's check
Check
Bonus check
For verification
Hold
processing
Rejected by Pix
Failed
     */

    mounted () {
      this.loadEntities().then(() => this.loadPaymethods())
    },

    watch: {
      project () {
        if (this.options.page != 1) {
          this.options.page = 1
        } else {
          this.search()
        }

        this.loadProjectOveriew(this.project)
      },
      options: {
        handler () {
          this.search()
        },
      },
      'filters.status.data' (filteredStatuses) {
        window.localStorage.setItem(STATUS_LOCAL_STORAGE_KEY, filteredStatuses.join(','))
      },
    },

    computed: {
      canEditTransactionParams() {
        return this.$store.state.auth.checkAccess({ key: 'payment_handler_update', value: true }) &&
              !this.$store.state.auth.checkAccess({key: 'deny_change_withdraw_data', value: true })
      },

      tableHeaders() {
        const headers = [...this.selectedHeaders(this.headers)]
        if (this.canEditTransactionParams) {
          headers.splice(-1, 0, [
            { text: '', sortable: false, value: 'edit', cellClass: 'pl-0-i pr-0-i' },
          ])
        }

        if (!this.projectHasAccountMessages) {
          const i = headers.findIndex(h => h.value === WITHDRAWAL_DATE_KEY)
          headers.splice(i, 1)
        }

        return headers
      },

      editTransactionDialog: {
        get() {
          return !!this.editDetailsTransaction
        },
        set(value) {
          if (!value) {
            this.editDetailsTransaction = null
          }
        }
      },

      isConfirmationDisplayed: {
        get() {
          return this.confirmationTarget !== null
        },

        set(value) {
          if (!value) {
            this.confirmationTarget = null
            return
          }

          this.confirmationTarget = value
        }
      },

      projectHasAccountMessages() {
        const e = (this.$store.state.auth.entities || []).find(x => x.entity_id === this.project)
        return e?.withdrawal_status_messages === true
      },

      currentWithdrawalDateById() {
        const map = {}

        for (const transaction of this.itemsInit) {
          const wd = get(transaction, WITHDRAWAL_DATE_KEY, null)
          if (wd) {
            map[transaction.account_transaction_id] = wd
          }
        }

        return map
      },
    },

    methods: {

      startCase: (k) => startCase(k),

      openPayoutDialog: function (transaction) {
        this.payoutDialog.balances = []
        this.loadBalances(transaction.paymethod)

        this.payoutDialog.data.transaction = cloneDeep(transaction)
        this.payoutDialog.data.fields = cloneDeep(transaction.details.params)
        this.payoutDialog.data.account = clone(trim(transaction.account))
        this.payoutDialog.data = cloneDeep(this.payoutDialog.data)

        for (let k in this.payoutDialog.data.fields) {
          if (isString(this.payoutDialog.data.fields[k])) {
            this.payoutDialog.data.fields[k] = trim(this.payoutDialog.data.fields[k])
          }
        }

        this.payoutDialog.loadingAccount = true

        API.call('/$v/payment_handler/withdraw_tokens.json', {
          account_transaction_id: transaction.account_transaction_id,
        }, null, this.project || this.project.value).then(resp => {

          this.payoutDialog.data.withdraw_tokens = resp.data
          return resp.data
        }).catch(e => {

          this.search()
        }).finally(() => {
          this.payoutDialog.loadingAccount = false
        })

        this.payoutDialog.show = true
      },

      payoutHandler: async function (transaction, fields, account) {

        let checkbox = []
        let confirmRes = true

        if (transaction.account_info.type == 'affiliate') {
          checkbox = [ { text: 'As real withdraw', name: 'real_transaction', value: false, class: 'primary darken-1' } ]
          confirmRes = await this.$root.$confirm('Confirm', `Confirm payout: ${transaction.amount} ${transaction.currency}`, { checkbox })
        }

        if (!confirmRes) {
          return
        }

        this.$refs.token_id_cb.blur()
        this.$nextTick(() => {
          account = this.$refs.token_id_cb.value

          this.payoutInProgress = true
          API.call('/$v/payment_handler/payout.json', {
            account_transaction_id: transaction.account_transaction_id,
            token_id: account,
            extra: reduce(checkbox, (r, f, k) => {
              r[f.name] = f.value
              return r
            }, {}),
            ...(transaction.wallet ? { wallet: transaction.wallet } : {}),
            ...fields
          }, { login: transaction.login }).then(resp => {

            this.$notification.show = true
            this.$notification.message = map(resp.data.messages, 'description').join('<br />')
            this.$notification.type = resp.data.status == 'success' ? resp.data.status : 'error'

            if (resp.data.status == 'success') {
              this.payoutDialog.show = false
            }

            if (resp.data.url) {
              this.openPopUp(resp.data.url)
            }

            return resp.data
          }).catch(e => {
            this.search()
          }).finally(() => {
            this.payoutInProgress = false
          })
        })

      },

      setTomorrowDate(item) {
        item.details.account_message.withdrawal_date = moment().add(1, 'days').format('YYYY-MM-DD')
        this.applyAccountMessagePreset(item, { message: ESTIMATED_DATE_MSG, type: ACCOUNT_MSG_TYPE_ESTIMATE })
      },

      loadPaymethods () {
        return API.call('/$v/paymethod/name_list.json', {}, null, this.project).then(resp => {
          let index = findIndex(this.headers, { value: 'paymethod' })

          this.headers[index].data = reduce(resp.data, (r, v) => {
            r.push(v.name)
            return r
          }, [])

          return resp.data
        }).finally(() => {
        })
      },

      openPopUp (href) {
        var d = document.documentElement,
          h = 400,
          w = 600,
          myWindow = window.open(href, 'myWindow', 'scrollbars=1,height=' + Math.min(h, screen.availHeight) + ',width=' + Math.min(w, screen.availWidth) + ',left=' + Math.max(0, ((d.clientWidth - w) / 2 + window.screenX)) + ',top=' + Math.max(0, ((d.clientHeight - h) / 2 + window.screenY)))

        // абзац для Chrome
        if (myWindow.screenY >= (screen.availHeight - myWindow.outerHeight)) {
          myWindow.moveTo(myWindow.screenX, (screen.availHeight - myWindow.outerHeight))
        }

        if (myWindow.screenX >= (screen.availWidth - myWindow.outerWidth)) {
          myWindow.moveTo((screen.availWidth - myWindow.outerWidth), myWindow.screenY)
        }

      },

      loadEntities () {
        return API.call('/users/entity_list.json').then(resp => {
          this.entities = resp.data
          return resp.data
        }).catch(e => {
        })
      },

      changeWallet (item, wallet) {

        if (get(item, 'details.allow_switch_wallet')) {
          this.payoutDialog.loadingWalletSwitch = true
          API.call('/$v/payment_handler/switch_wallet.json', {
            account_transaction_id: item.account_transaction_id,
            currency: wallet.currency,
          }, null, this.project || this.project.value).then(r => {
            if (get(r, 'data.amount')) {
              item.amount = get(r, 'data.amount')
              item.currency = get(r, 'data.currency')
              item.wallet = { amount: item.amount, currency: item.currency }
            }
          }).catch(e => {
          }).finally(() => {
            this.payoutDialog.loadingWalletSwitch = false
          })
        }
      },

      checkStatusChangedToComplete: function (item) {
        return get(item, 'status') != get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'status') && get(item, 'status') === 'complete'
      },

      updateTransaction: async function (item, { afterConfirm, skipConfirmation = false } = {
        afterConfirm: () => {},
        skipConfirmation: false,
      }) {
        if (!this.$store.state.auth.checkAccess({ key: 'payment_handler_update', value: true })) {
          return
        }

        let buttons = [
          { text: 'Confirm', value: true, class: 'primary darken-1' },
          { text: 'Cancel', value: false, class: 'grey' },
        ]

        let statusChangedToComplete = this.checkStatusChangedToComplete(item)

        if (statusChangedToComplete) {
          buttons = [
            { text: 'Change status', value: true, class: 'primary darken-1' },
            { text: 'Change status and send mail', value: 'complete_withdraw_mail', class: 'primary darken-1' },
            { text: 'Cancel', value: false, class: 'grey' },
          ]
        }

        let checkbox = []

        if (item.account_info.type == 'affiliate' && statusChangedToComplete) {
          checkbox = [ { text: 'As real withdraw', name: 'real_transaction', value: false, class: 'primary darken-1' } ]
        }

        let confirmRes = await (skipConfirmation ? true : this.$root.$confirm('Confirm', 'Do you want save changes?', { width: buttons.length >= 3 ? 565 : 400, buttons, checkbox }))

        if (confirmRes) {
          afterConfirm?.()

          let fields = [
            KYC_VERIFICATION_KEY,
            'details.kyc.docs_approved',
            'details.kyc.review',
            'details.account_message.message_type',
            'details.account_message.status_message',
            'details.account_message.display_to_account',
            WITHDRAWAL_DATE_KEY,
          ]
          let params = {}

          for (let k of fields) {
            if (get(item, k) != get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), k)) {
              params[k] = get(item, k)
            }
          }

          return API.call('/$v/payment_handler/update.json', {
            account_id: item.account_id,
            account_transaction_id: item.account_transaction_id,
            status: get(item, 'status') != get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'status') ? item.status : undefined,
            comment: item.comment,
            amount: item.amount,
            fields: params,
            extra: reduce(checkbox, (r, f, k) => {
              r[f.name] = f.value
              return r
            }, {}),
            ...statusChangedToComplete ? { send_complete_mail: confirmRes == 'complete_withdraw_mail' } : {},
          }, null, this.project || this.project.value).then(resp => {

            if (resp.data.status == item.status || resp.data.comment == item.comment) {
              if (resp.data.comment == item.comment) {
                set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'comment', item.comment)
              }
              if (resp.data.status == item.status) {
                set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'status', item.status)
              }

              for (const key of [WITHDRAWAL_DATE_KEY, KYC_VERIFICATION_KEY]) {
                if (key in resp.data) {
                  set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), key, resp.data[key])
                  set(find(this.items, { account_transaction_id: item.account_transaction_id }), key, resp.data[key])
                }
              }
            } else {

              this.$nextTick(function () {
                if (resp.data['comment']) {
                  set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'comment', resp.data['comment'])
                  item.comment = resp.data.comment
                }
                if (resp.data['status']) {
                  set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'status', resp.data['status'])
                  item.status = resp.data.status
                }
              })

            }

            this.$showSuccess('Transaction updated')

            return resp.data
          }).catch(e => {
            this.search()
          })
        } else {
          this.$nextTick(function () {
            item.comment = get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'comment')
            item.status = get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'status')
          })
        }
      },

      search: async function () {
        this.loading = true
        API.call('/$v/payment_handler/list.json', {
          from: this.from,
          to: this.to,
          type: 'withdraw',
          options: this.options,
          only_selected: true,
          filters: reduce(this.filters, (r, f, k) => {
            if (!isEmpty(f.data)) {
              r[k] = f.data
            }
            return r
          }, {}),
          limit: 50
        }, null, this.project).then(resp => {

          this.total = resp.total
          this.items = cloneDeep(resp.data)
          this.itemsInit = cloneDeep(resp.data)

          return resp.data
        }).then(() => this.loadTableColums('withdraw')).catch(e => {
        }).finally(() => {
          this.loading = false
        })
      },

      loadBalances: function (paymethod) {
        if (!this.$store.state.auth.checkAccess({ key: 'load_merchant_balances', value: true })) {
          return
        }

        this.payoutDialog.loadingBalances = true

        API.call('/$v/payment_handler/merchant_balance.json', { paymethod }, null, this.project).then(resp => {
          if (resp.data) {
            this.payoutDialog.balances = resp.data
          }
          return resp.data
        }).catch(e => {
        }).finally(() => {
          this.payoutDialog.loadingBalances = false
        })

      },

      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      columnValueList (val) {
        if (val == 'status') {
          return this.statuses
        }
        return this.items.map(d => d[val])
      },

      onTransactionDetailsUpdate(transaction) {
        this.$root.$confirm('Confirm', 'Update transaction params?').then(yes => {
          if (!yes) {
            return
          }

          this.isUpdatingTransactionDetails = true
          return API.call('/$v/payment_handler/update_details.json', transaction, null, this.project)
            .then(resp => {
              const target = this.items.find(({account_transaction_id}) => account_transaction_id === resp.data.account_transaction_id)

              if (target) {
                if (target.details?.iban_details && resp.data.iban_details) {
                  Object.assign(target.details.iban_details, resp.data.iban_details)
                }
                if (target.details?.params && resp.data.params) {
                  Object.assign(target.details.params, resp.data.params)
                }
                this.$set(target.details, '_details_update_meta', resp.data.meta)

                this.editTransactionDialog = false
                this.$showSuccess('Successfully adjusted params')
              }
            })
            .finally(() => {
              this.isUpdatingTransactionDetails = false
            })
        })
      },

      transactionDetailsCanBeConfigured(transaction) {
        return transaction.status === 'pending' &&
               !isEmpty(omit(transaction.details.params, ['iov_flag', 'account', 'fp_flag'])) ||
               !isEmpty(transaction.details?.iban_details)
      },

      loadProjectOveriew(entity_id) {
        this.isLoadingProjectOveriview = true
        this.projectOverview = {}
        return API.call('/$v/payment_handler/project_overview.json', {}, null, entity_id)
          .then(r => this.projectOverview = r.data)
          .finally(() => {
            this.isLoadingProjectOveriview = false
          })
      },

      fmtDateDiff(ts) {
        if (!ts) {
          return 'N/A'
        }

        return moment(ts).fromNow()
      },

      applyDescriptionPreset(transaction, preset) {
        if (typeof preset.account_message === 'string' && this.projectHasAccountMessages) {
          this.applyAccountMessagePreset(transaction, { message: preset.account_message, type: preset.type })
        }
      },

      applyAccountMessagePreset(transaction, preset) {
        if (preset.type === ACCOUNT_MSG_TYPE_ESTIMATE) {
          // Setting a date requires clearing the comment, estimate is only used when a date is set
          transaction.comment = ''
        }

        this.$set(transaction.details, 'account_message', {
          ...transaction.details.account_message,
          message_type: preset.type,
          status_message: preset.message.replace('{{withdrawal_date}}', transaction.details.account_message.withdrawal_date ?? 'N/A'),
          display_to_account: !!preset.message,
        })
      },

      onCustomConfirm() {
        const stableRef = this.items.find(item => item.account_transaction_id === this.confirmationTarget.account_transaction_id)

        if (stableRef) {
          this.updateTransaction(stableRef, { skipConfirmation: true })
            .then(() => this.loadDateStats(stableRef, true))
        }

        this.confirmationTarget = null
      },

      loadDateStats(transaction, forceLoad = false) {
        if (!forceLoad && (transaction.account_id in this.withdrawalSchedulesByAccountId)) {
          return
        }

        return API.call('/$v/payment_handler/list_schedule.json', {
          account_id: transaction.account_id,
        }, null, this.project)
          .then(r => {
            const countByDate = {}

            for (const entry of r.data) {
              if (!(entry.withdrawal_date in countByDate)) {
                countByDate[entry.withdrawal_date] = 0
              }

              countByDate[entry.withdrawal_date]++
            }

            this.$set(this.withdrawalSchedulesByAccountId, transaction.account_id, countByDate)
          })
      },

      dateEvents(account_id, date, transaction_id) {
        const events = []
        let decrement = 0

        if (this.currentWithdrawalDateById[transaction_id] === date) {
          events.push('purple')
          decrement = 1
        }

        const count = this.withdrawalSchedulesByAccountId[account_id]?.[date]
        if (count && count > 0) {
          const adjustedCount = count - decrement

          if (adjustedCount === 1) {
            events.push('primary')
          } else if (adjustedCount > 1) {
            events.push('warning')
          }
        }

        return events
      },
    },
  }
</script>
